var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custommodule"},[_vm._v(" "+_vm._s(_vm.datas.demo)+" "),_c('img',{attrs:{"src":_vm.datas.img,"alt":""}}),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }